// directives imports
import { SwPasswordValidationDirective } from './sw-password-validation';
import { SwChangeNotifierDirective } from './sw-change-notifier';
import { SwClickDirective } from './sw-click';
import { SwEditableInputDirective } from './sw-editable-input';
import { SwIfWholesaleDirective } from './sw-if-wholesale';

export const directives: any[] = [
  // directives export
  SwPasswordValidationDirective,
  SwChangeNotifierDirective,
  SwClickDirective,
  SwEditableInputDirective,
  SwIfWholesaleDirective,
];
